module.exports = __webpack_public_path__ + "Roboto-Bold.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Bold.eot
// module id = ../../../../../src/font/roboto/Roboto-Bold.eot
// module chunks = 1